<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "MediaGroupMediaArchiveWrapper"
    }
</script>

<style scoped>

</style>